import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

import { IonicModule } from '@ionic/angular';

import { PastOrderPageRoutingModule } from './past-order-routing.module';

import { PastOrderPage } from './past-order.page';
import { TranslateModule } from '@ngx-translate/core';
import { PipeModule } from '../../core/pipe.module';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    PastOrderPageRoutingModule,
    TranslateModule,
    PipeModule
  ],
  declarations: [PastOrderPage],
  exports: [PastOrderPage]
})
export class PastOrderPageModule { }
